import { Injectable } from '@angular/core';
import { Action, MemoizedSelector } from '@ngrx/store';
import { from, Observable } from 'rxjs';

@Injectable()
export class CommonUtilsTestService {
  instanceColor$ = new Observable<string>();
  instanceThemeColor$ = new Observable<string>();

  storeDispatch(action: Action): void {}

  storeSelect<T>(selector: MemoizedSelector<object, T>): Observable<T> {
    return new Observable<T>();
  }

  storeSelectOne<T>(
    selector: MemoizedSelector<object, T>,
    waitWhileUndefined = false
  ): Promise<T> {
    return new Promise<T>(resolve => resolve({} as T));
  }

  checkFileSystemPermission(): Promise<boolean> {
    return new Promise<boolean>(resolve => resolve(true));
  }

  takePicture(options: any): Observable<any> {
    return from(
      new Promise<any>(resolve =>
        resolve({ base64String: '', dataUrl: '', webPath: '' })
      )
    );
  }

  checkCameraPermission(): void {}

  vibrate(): void {}

  openNativeOSSettingPopup(): void {}

  openExternalUrlInBrowser(url: string): void {}

  generateFilename(blobType: string): string {
    return 'sample-file.jpg';
  }

  checkDirectoryExists(directory: string): Promise<any> {
    return new Promise<any>(resolve => resolve({ files: [] }));
  }

  createDirectory(directory: string): Promise<void> {
    return new Promise<void>(resolve => resolve(void 0));
  }

  chooseFile(): Observable<any> {
    return from(new Promise<any>(resolve => resolve({ files: [] })));
  }
}
